import { createAction } from 'redux-actions';

import * as ACTION from './constants';

export const scanBarcode = createAction(ACTION.SCAN_BARCODE_FORM.REQUEST);
export const successScanBarcode = createAction(ACTION.SCAN_BARCODE_FORM.SUCCESS);
export const failedTransportWarehouse = createAction(ACTION.TRANSPORT_WAREHOUSE.FAILED)
export const scanReceived = createAction(ACTION.SCAN_RECEIVED.REQUEST);
export const scanReceivedBag = createAction(ACTION.SCAN_RECEIVED_BAG.REQUEST);
